import Loading from '../components/Loading';
import { useAuth } from '../contexts/AuthProvider';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
    const auth = useAuth();

    if (auth.loading) {
        return <Loading />; // Or a loading spinner
    }
    if (!auth.isAuthenticated) {
        return null;
    }
    return <>{children}</>;
}
